<div class="icon-nav">
  <ul>

  
    <li class="onhover-div" *ngIf="!productsService?.catalogMode" [routerLink]="'/home/cart'">
      <div>
        <a class="link-cart">
          <span class="material-icons icon-header">shopping_cart</span> <span class="hidden-xs">CARRITO</span>
        </a>
      </div>
      <span class="cart_qty_cls" *ngIf="cartItemCount > 0">{{cartItemCount}}</span>
      <!--
      <ul class="show-div shopping-cart" *ngIf='shoppingCartItems.length'>
        <li *ngFor="let item of shoppingCartItems">
          <div class="media">
            <a [routerLink]="['/home/left-sidebar/product', item.product.sku]"><img class="mr-3" [src]="getUrl(item.product.photos)" alt="Generic placeholder image"></a>
            <div class="media-body">
              <a [routerLink]="['/home/left-sidebar/product', item.product.sku]"><h4>{{ item.product.name }}</h4></a>
              <h4><span>{{ item.quantity }} x {{ item.product.unitPrice | currency:productsService?.currency:'symbol' }}</span></h4>
            </div>
          </div>
          <div class="close-circle">
            <a (click)="removeItem(item)"><i class="fa fa-times" aria-hidden="true"></i></a>
          </div>
        </li>
        <li>
          <div class="total">
            <h5>subtotal : <span>{{ getTotal() | async | currency:productsService?.currency:'symbol'}}</span></h5>
          </div>
        </li>
        <li>
          <div class="buttons">
            <a [routerLink]="'/home/cart'" class="view-cart">{{'cart-table.view-cart' | translate}}</a>
            <a [routerLink]="'/home/checkout'" class="checkout">{{'cart-table.check-out' | translate}}</a>
          </div>
        </li>
      </ul>--> 
    </li>
<li>
    <div class="top-header">
      <div class="container">
        <app-topbar></app-topbar>
      </div>
    </div>
  </li>
  </ul>
</div>
<!-- Search -->
<div id="search-overlay" class="search-overlay" *ngIf="show" [ngStyle]="{ 'display': 'block' }">
  <div>
    <span class="closebtn" title="Close Overlay" (click)="closeSearch()">×</span>
    <div class="overlay-content">
      <div class="container">
        <div class="row">
          <div class="col-xl-12">
            <form>
              <div class="form-group">
                <input type="text" class="form-control" id="inputSearch" placeholder="{{'search' | translate}}"
                [(ngModel)]="articleFilter.articleFind" name="inputSearch">
              </div>
              <button type="submit" class="btn btn-primary" (click)="find()"><i class="fa fa-search"></i></button>
            </form>            
          </div>
        </div>
        <div class="row">
          <div class="col-xl-12 button-clean">
            <a (click)="clean()" class="btn btn-solid">{{'search-clean' | translate}}</a>
          </div>
        </div>
    
      </div>
    </div>
  </div>
</div>
